import { render } from "./Svgs.vue?vue&type=template&id=38bcf70e"
import script from "./Svgs.vue?vue&type=script&lang=ts"
export * from "./Svgs.vue?vue&type=script&lang=ts"
script.render = render

export default script